import React, { useState } from "react";
import { I } from "./Icons";

export function Toggle({ on, onChange, T }) {
  return (
    <div onClick={onChange} style={{ width:42, height:24, borderRadius:12, background:on?T.accent:T.border, cursor:"pointer", position:"relative", transition:"background 0.2s", flexShrink:0 }}>
      <div style={{ position:"absolute", top:3, left:on?21:3, width:18, height:18, borderRadius:"50%", background:"#fff", transition:"left 0.18s", boxShadow:"0 1px 4px rgba(0,0,0,0.25)" }} />
    </div>
  );
}

export function Toast({ msg, T }) {
  if (!msg) return null;
  return (
    <div style={{ position:"fixed", bottom:28, left:"50%", transform:"translateX(-50%)", background:T.toastBg, color:T.toastText, padding:"10px 22px", borderRadius:24, fontSize:13, fontWeight:600, zIndex:9999, boxShadow:`0 4px 20px ${T.shadowMd}`, whiteSpace:"nowrap", pointerEvents:"none" }}>
      {msg}
    </div>
  );
}

export function ModalBackdrop({ onClose, children, T, bottom=false }) {
  return (
    <div style={{ position:"fixed", inset:0, background:T.modalBg, zIndex:200, display:"flex", alignItems:bottom?"flex-end":"center", justifyContent:"center" }} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()}>{children}</div>
    </div>
  );
}

export function SectionLabel({ children, T }) {
  return <div style={{ marginTop:18, marginBottom:4, fontSize:10, fontWeight:700, color:T.textMuted, letterSpacing:1.2, textTransform:"uppercase", borderBottom:`1px solid ${T.border}`, paddingBottom:6 }}>{children}</div>;
}

export function FieldLabel({ children, T }) {
  return <label style={{ display:"block", fontSize:10, fontWeight:700, color:T.textSub, marginBottom:4, marginTop:10, letterSpacing:1, textTransform:"uppercase" }}>{children}</label>;
}

export function Input({ style:s, T, ...p }) {
  return <input style={{ width:"100%", background:T.inputBg, border:`1.5px solid ${T.inputBorder}`, borderRadius:9, padding:"11px 13px", fontSize:14, color:T.text, outline:"none", marginBottom:4, ...s }} {...p} />;
}

export function Select({ T, children, style:s, ...p }) {
  return <select style={{ width:"100%", background:T.inputBg, border:`1.5px solid ${T.inputBorder}`, borderRadius:9, padding:"11px 13px", fontSize:14, color:T.text, outline:"none", marginBottom:4, cursor:"pointer", ...s }} {...p}>{children}</select>;
}

export function Btn({ T, variant="primary", style:s, children, ...p }) {
  const styles = {
    primary:   { background:T.accent,      color:T.accentText,  border:"none" },
    secondary: { background:T.surfaceAlt,  color:T.text,        border:`1px solid ${T.border}` },
    danger:    { background:T.danger,      color:T.dangerText,  border:"none" },
  };
  return (
    <button style={{ borderRadius:9, padding:"12px 16px", fontSize:14, fontWeight:700, cursor:"pointer", letterSpacing:0.3, display:"flex", alignItems:"center", justifyContent:"center", gap:8, ...styles[variant], ...s }} {...p}>
      {children}
    </button>
  );
}

export function PageHeader({ T, onBack, title, px=16 }) {
  return (
    <div style={{ background:T.surface, padding:`13px ${px}px`, display:"flex", alignItems:"center", gap:10, borderBottom:`1px solid ${T.border}`, position:"sticky", top:52, zIndex:10 }}>
      {onBack && <button onClick={onBack} style={{ background:"none", border:"none", color:T.accent, cursor:"pointer", display:"flex", alignItems:"center", gap:6, fontWeight:700, fontSize:13, padding:0, flexShrink:0 }}><I n="Back" size={15} /> Voltar</button>}
      <span style={{ fontWeight:800, fontSize:15, color:T.text }}>{title}</span>
    </div>
  );
}

export function Spinner({ T }) {
  return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", padding:48 }}>
      <div style={{ width:32, height:32, border:`3px solid ${T.border}`, borderTop:`3px solid ${T.accent}`, borderRadius:"50%", animation:"spin 0.8s linear infinite" }} />
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

export function InfoRow({ icon, label, value, T, accent }) {
  return (
    <div style={{ display:"flex", alignItems:"flex-start", gap:12, padding:"10px 0", borderBottom:`1px solid ${T.sep}` }}>
      <span style={{ color:accent?T.accent:T.textSub, marginTop:1, flexShrink:0, display:"flex" }}><I n={icon} size={16} /></span>
      <div>
        <div style={{ fontSize:10, fontWeight:700, color:T.textMuted, letterSpacing:0.8, textTransform:"uppercase" }}>{label}</div>
        <div style={{ fontSize:14, color:accent?T.accent:T.text, fontWeight:accent?700:400, marginTop:1 }}>{value}</div>
      </div>
    </div>
  );
}

export function MRow({ icon, label, T, onClick, color }) {
  const [hov,setH] = useState(false);
  return (
    <button onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)} onClick={onClick}
      style={{ display:"flex", alignItems:"center", gap:12, width:"100%", background:hov?T.surfaceHov:"transparent", border:"none", textAlign:"left", padding:"12px 18px", fontSize:14, color:color||T.text, cursor:"pointer", transition:"background 0.12s" }}>
      <I n={icon} size={17} style={{ color:color||T.textSub }} />{label}
    </button>
  );
}

export function SideNavItem({ icon, label, T, active, onClick }) {
  return (
    <button onClick={onClick} style={{ display:"flex", alignItems:"center", gap:12, width:"100%", background:active?T.surfaceHov:"transparent", border:"none", borderLeft:`3px solid ${active?T.accent:"transparent"}`, textAlign:"left", padding:"11px 18px", fontSize:13, color:active?T.accent:T.text, cursor:"pointer", fontWeight:active?700:400 }}>
      <I n={icon} size={17} style={{ color:active?T.accent:T.textSub }} />{label}
    </button>
  );
}
